import { formatDateTimeSk } from "app/utils/dateFormat";

/**
 * Format ISO date string to readable format
 * @param {string} isoString - ISO date string
 * @returns {string} Formatted date string
 */
export const formatDateTime = (isoString) => {
  return formatDateTimeSk(isoString);
};

/**
 * Get status badge color
 * @param {string} status - Job status
 * @returns {string} MUI color name
 */
export const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case "done":
    case "completed":
    case "success":
      return "success";
    case "running":
    case "processing":
      return "warning";
    case "failed":
    case "error":
      return "error";
    case "queued":
    case "pending":
      return "info";
    default:
      return "default";
  }
};
